import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import TicketReceiptModal from '../../components/TicketReceiptModal';
import SupervisorBankCodeField from '../../components/SupervisorBankCodeField';
import SupervisorGroupCodeField from '../../components/SupervisorGroupCodeField';
import DateField from '../../components/DateField';
import LotteryCodeField from '../../components/LotteryCodeField';
import { searchSupervisorVerifyTickets } from '../../api/supervisor';
import { todayISO } from '../../utils/date';
import './SupervisorVerifierTicketPage.css';

// Variante superviseur (2026-09-16) de pages/central/VerifierTicketPage.jsx —
// pas de radio Bank/Group (deja son propre perimetre), remplace par des
// champs Banque/Groupe optionnels et mutuellement exclusifs restreints a SES
// banks/groups (vide = toutes). Meme UI/UX que la company (texte + icone 🔍 +
// modal, pas de <select> — demande explicite 2026-09-17).
const SupervisorVerifierTicketPage = () => {
  const [bankId, setBankId] = useState('');
  const [bankName, setBankName] = useState('');
  const [groupId, setGroupId] = useState('');
  const [groupName, setGroupName] = useState('');
  const [date, setDate] = useState(todayISO());
  const [loterieDe, setLoterieDe] = useState('0');
  const [loterieDeName, setLoterieDeName] = useState('');
  const [loterieUp, setLoterieUp] = useState('0');
  const [loterieUpName, setLoterieUpName] = useState('');
  const [ticket, setTicket] = useState('');

  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedTicket, setSelectedTicket] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const data = await searchSupervisorVerifyTickets({
        bank: bankId, group: groupId, date, tirageFrom: loterieDe, tirageUp: loterieUp, ticket,
      });
      setResults(data);
      setSearched(true);
    } catch (err) {
      setError('Recherche impossible — verifie que le serveur backend tourne.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <SupervisorLayout>
      <p className="svvt-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svvt-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/central" className="svvt-link">Central</Link>
        {' >> '}
        <span className="svvt-current">Verifier le Ticket</span>
      </p>

      <div className="svvt-card">
        <div className="svvt-card-header">
          <span className="svvt-card-title">Verifiez Ticket</span>
        </div>
        <div className="svvt-card-body">
          <form onSubmit={handleSearch} className="svvt-form">
            <div className="svvt-row">
              <label className="svvt-label">Banque</label>
              <SupervisorBankCodeField
                value={bankId}
                name={bankName}
                onChange={(id) => { setBankId(id); setBankName(''); }}
                onResolve={(id, nm) => {
                  setBankId(id); setBankName(nm);
                  setGroupId(''); setGroupName('');
                }}
                inputClass="svvt-input svvt-input-sm"
                iconClass="svvt-icon-btn"
                nameClass="svvt-bank-name"
              />

              <label className="svvt-label svvt-label-gap">Groupe</label>
              <SupervisorGroupCodeField
                value={groupId}
                name={groupName}
                onChange={(id) => { setGroupId(id); setGroupName(''); }}
                onResolve={(id, nm) => {
                  setGroupId(id); setGroupName(nm);
                  setBankId(''); setBankName('');
                }}
                inputClass="svvt-input svvt-input-sm"
                iconClass="svvt-icon-btn"
                nameClass="svvt-bank-name"
              />
            </div>

            <div className="svvt-row">
              <label className="svvt-label">De</label>
              <DateField className="svvt-input svvt-input-date" value={date} onChange={setDate} />
            </div>

            <div className="svvt-row">
              <label className="svvt-label">Loterie De</label>
              <LotteryCodeField
                value={loterieDe}
                name={loterieDeName}
                onChange={(code) => { setLoterieDe(code); setLoterieDeName(''); }}
                onResolve={(code, nm) => { setLoterieDe(code); setLoterieDeName(nm); }}
                inputClass="svvt-input svvt-input-sm"
                iconClass="svvt-icon-btn"
                nameClass="svvt-bank-name"
              />

              <label className="svvt-label svvt-label-gap">Loterie Up</label>
              <LotteryCodeField
                value={loterieUp}
                name={loterieUpName}
                onChange={(code) => { setLoterieUp(code); setLoterieUpName(''); }}
                onResolve={(code, nm) => { setLoterieUp(code); setLoterieUpName(nm); }}
                inputClass="svvt-input svvt-input-sm"
                iconClass="svvt-icon-btn"
                nameClass="svvt-bank-name"
              />
            </div>

            <div className="svvt-row">
              <label className="svvt-label">Ticket</label>
              <input
                className="svvt-input svvt-input-sm"
                type="text"
                value={ticket}
                onChange={(e) => setTicket(e.target.value)}
              />
            </div>

            <button type="submit" className="svvt-search-btn" disabled={loading}>
              {loading ? 'Recherche...' : 'Chercher'}
            </button>

            {error && <p className="svvt-error">{error}</p>}
          </form>
        </div>
      </div>

      {searched && (
        <div className="svvt-card">
          <div className="svvt-card-header">
            <span className="svvt-card-title">Listado Tickets</span>
          </div>
          <div className="svvt-card-body">
            <table className="svvt-table">
              <thead>
                <tr>
                  <th>Ticket</th>
                  <th>Loterie</th>
                  <th>Date</th>
                  <th>Temp</th>
                  <th>Montant</th>
                  <th>Annule?</th>
                </tr>
              </thead>
              <tbody>
                {results.map((row) => {
                  const created = new Date(row.created_at);
                  return (
                    <tr key={row.id} className="svvt-row-hover" onClick={() => setSelectedTicket(row)}>
                      <td>{row.no ?? '-'}</td>
                      <td>{row.tirage_name}</td>
                      <td>{created.toLocaleDateString()}</td>
                      <td>{created.toLocaleTimeString()}</td>
                      <td>{Number(row.total_amount).toFixed(2)}</td>
                      <td>{row.is_deleted ? 'Oui' : 'No'}</td>
                    </tr>
                  );
                })}
                {results.length === 0 && (
                  <tr><td colSpan={6} className="svvt-empty">Aucun ticket trouvé.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {selectedTicket && (
        <TicketReceiptModal
          ticket={selectedTicket}
          bank={selectedTicket.bank}
          bankName={selectedTicket.bank_name}
          onClose={() => setSelectedTicket(null)}
        />
      )}
    </SupervisorLayout>
  );
};

export default SupervisorVerifierTicketPage;
